import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import Cookie from '../components/Cookie';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-[#1c1c29] relative z-10" aria-labelledby="footer">
      <div className="max-w-screen-xl px-4 py-6 mx-auto space-y-6 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-between items-start gap-8">
          <div className="flex flex-col items-start sm:items-start space-y-4" aria-labelledby="contact-info">
            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">
                <PhoneIcon className="h-5 w-5 text-white" />
              </div>
              <a href="tel:+905333600068" className="text-base text-white hover:text-[#dcbc5c] transition-all" aria-label="Call us at +90 533 360 00 68">
                +90 533 360 00 68
              </a>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">
                <EnvelopeIcon className="h-5 w-5 text-white" />
              </div>
              <a href="mailto:info@junyazilim.com" className="text-base text-white hover:text-[#dcbc5c] transition-all" aria-label="Send email to info@junyazilim.com">
                info@junyazilim.com
              </a>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">
                <MapPinIcon className="h-5 w-5 text-white" />
              </div>
              <span className="text-base text-white hover:text-[#dcbc5c] transition-all" aria-label="Our location in Istanbul, Turkey">
                Istanbul, Turkey
              </span>
            </div>
          </div>

          <nav className="flex flex-col items-end sm:items-end space-y-2" aria-labelledby="navigation-links">
            <Link to="/" className="text-base text-white hover:text-[#dcbc5c]" aria-label="Anasayfa">
              {t('home')}
            </Link>
            <Link to="/about" className="text-base text-white hover:text-[#dcbc5c]" aria-label="Hakkımızda">
              {t('about')}
            </Link>
            <Link to="/contact" className="text-base text-white hover:text-[#dcbc5c]" aria-label="İletişim">
              {t('contact')}
            </Link>
          </nav>
        </div>

        <div className="footer-bottom text-center text-sm text-gray-200 mt-10 border-t-2 border-gray-400 pt-5" aria-labelledby="footer-bottom">
          <p>&copy; {currentYear} {t('footerall')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
